// extracted by mini-css-extract-plugin
export var deliveryRow = "_l2-a";
export var fixedHeight = "_l2-4";
export var freightLogo = "_l2-9";
export var fullWidth = "_l2-3";
export var priceColumn = "_l2-5";
export var radioSelected = "_l2-7";
export var radioUnselected = "_l2-6";
export var selectedOption = "_l2-2";
export var selectedOptionContainer = "_l2-1";
export var selection = "_l2-0";
export var tallSkeletonText = "_l2-8";